import axios from "../../../axios";

export const deleteSecret = async (secretData) => {
    try{  
    let { status } = await axios.delete(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/vault/${secretData.secret_id}`);
    return status
} catch (e) {
    console.log(e.message);
}
}